const DOMAIN_SPEECH_TYPES = new Set(['SA', 'SASemantic', 'SAkeyword', 'LA', 'Wordcloud']);
const ALWAYS_AUDIO_TYPES = new Set(['Cloze_with_passage', 'Cloze_with_conversation', 'VK', 'IELTS']);

export const SUBMIT_KIND = {
  TEXT: 'text',
  AUDIO: 'audio',
};

export const FEEDBACK_KIND = {
  TEXT: 'text',
  AUDIO: 'audio',
};

export function getQuestionType(question) {
  return question?.type ?? question?.qtype ?? question?.question_type ?? '';
}

export function getNormalizedQuestionType(question) {
  return String(getQuestionType(question) || '').trim().toUpperCase();
}

export function isInstructionQuestion(question) {
  return getNormalizedQuestionType(question) === 'INS';
}

export function getQuestionDomain(question) {
  const raw = question?.domain ?? question?.qdomain ?? question?.question_domain ?? '';
  if (Array.isArray(raw)) return raw.includes('S') ? 'S' : (raw[0] ?? '');
  return String(raw || '').trim();
}

export function isSpeechDomain(question) {
  return getQuestionDomain(question) === 'S';
}

export function isAudioSubmitQuestion(question) {
  const type = getQuestionType(question);
  if (ALWAYS_AUDIO_TYPES.has(type)) return true;
  return DOMAIN_SPEECH_TYPES.has(type) && isSpeechDomain(question);
}

function hasAudioFeedbackEvidence(feedbackData) {
  const answer = feedbackData?.answer ?? feedbackData;
  return answer?.user_answer === 'audio'
    || Boolean(answer?.file_url)
    || Boolean(answer?.answer_audio)
    || Boolean(answer?.speech_feedback)
    || Boolean(answer?.phrase_feedback)
    || Boolean(answer?.accuracy)
    || Boolean(answer?.pace);
}

export function isAudioFeedbackQuestion(feedbackData) {
  const question = feedbackData?.question ?? feedbackData;
  const type = getQuestionType(question);
  const domain = getQuestionDomain(question);
  if (ALWAYS_AUDIO_TYPES.has(type)) return true;
  if (DOMAIN_SPEECH_TYPES.has(type) && domain) return domain === 'S';
  return DOMAIN_SPEECH_TYPES.has(type) && hasAudioFeedbackEvidence(feedbackData);
}

export function getSubmitKind(question) {
  return isAudioSubmitQuestion(question) ? SUBMIT_KIND.AUDIO : SUBMIT_KIND.TEXT;
}

export function getFeedbackKind(feedbackData) {
  return isAudioFeedbackQuestion(feedbackData) ? FEEDBACK_KIND.AUDIO : FEEDBACK_KIND.TEXT;
}
